import { __decorate } from "tslib";
import { customElement } from "@microsoft/fast-element";
import { SearchBox } from "./search-box";
import { SearchBoxTemplate as template } from "./search-box.template";
import { SearchBoxStyles as styles } from "./search-box.styles";
/**
 * @public
 * @remarks
 * HTML Element: \<msft-search-box\>
 *
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/delegatesFocus | delegatesFocus}
 */
let MsftSearchBox = class MsftSearchBox extends SearchBox {
};
MsftSearchBox = __decorate([
    customElement({
        name: "msft-search-box",
        template,
        styles,
        shadowOptions: {
            delegatesFocus: true,
        },
    })
], MsftSearchBox);
export { MsftSearchBox };
